import { render, staticRenderFns } from "./CustomerOrderForm.vue?vue&type=template&id=83142a10&scoped=true&"
import script from "./CustomerOrderForm.vue?vue&type=script&lang=js&"
export * from "./CustomerOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrderForm.vue?vue&type=style&index=0&id=83142a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83142a10",
  null
  
)

export default component.exports